import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
//import MockService from "@/core/mock/mock.service";
import { VERIFY_AUTH, LOGOUT } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import RoleService from "@/core/services/role.service";
Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
import VueAos from 'vue-aos'
// Vue 3rd party plugins
import EventBus from './core/plugins/eventBus'
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import VueCurrencyFilter from 'vue-currency-filter'
import VueProgressBar from 'vue-progressbar'
import VueMask from 'v-mask'
import money from 'v-money'
import JsonExcel from "vue-json-excel";
// API service init
ApiService.init();

// Remove this to disable mock API
//MockService.init();


router.beforeEach((to, from, next) => {
  
  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);
  
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);
  
  //chequeamos los permisos del modulo
  const { authorize } = to.meta;
  const currentRole = RoleService.getRole();

  if (authorize) {
    
      // check if route is restricted by role
      if (authorize.length && !authorize.includes(currentRole)) {
          // role not authorised so redirect to home page
          store.dispatch(LOGOUT);
          return next({ path: '/login' });
      }
  }

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});
Vue.use(EventBus);
Vue.use(VueAos);
Vue.use(VueMask);

Vue.use(VueCurrencyFilter,
  {
    symbol : '$',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  })

Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: '$ ',
  suffix: '',
  precision: 0,
  masked: false})
Vue.component("downloadExcel", JsonExcel);
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount("#app");
